if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('Product form submit handler called');
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('Submit button is disabled, returning');
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Check for selected design add-ons and add them to cart
            console.log('Main product added successfully, checking for add-ons...');
            const selectedAddons = this.getSelectedDesignAddons();
            console.log('Selected addons:', selectedAddons);
            
            if (selectedAddons.length === 0) {
              console.log('No add-ons selected, using original response');
              return Promise.resolve(response);
            }
            
            return this.addDesignAddonsToCart(selectedAddons, formData, response);
          })
          .then((updatedResponse) => {
            if (!updatedResponse || this.error) return;
            
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: updatedResponse,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(updatedResponse);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(updatedResponse);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      getSelectedDesignAddons() {
        // Search within the form first, then fallback to document
        let checkboxes = this.form.querySelectorAll('.design-option__checkbox:checked');
        
        // If not found in form, try searching in the entire product-form element
        if (checkboxes.length === 0) {
          checkboxes = this.querySelectorAll('.design-option__checkbox:checked');
        }
        
        // Last resort: search in document
        if (checkboxes.length === 0) {
          checkboxes = document.querySelectorAll('.design-option__checkbox:checked');
        }
        
        const addons = [];
        
        console.log('Found checked checkboxes:', checkboxes.length);
        console.log('Searching in form:', this.form);
        console.log('All checkboxes in form:', this.form.querySelectorAll('.design-option__checkbox'));
        
        checkboxes.forEach(checkbox => {
          const variantId = checkbox.value;
          console.log('Checkbox value (variant ID):', variantId, 'Checkbox:', checkbox);
          if (variantId) {
            addons.push({
              id: variantId,
              quantity: 1
            });
          }
        });
        
        console.log('Selected addons to add:', addons);
        return addons;
      }

      addDesignAddonsToCart(addons, originalFormData, originalResponse) {
        if (!addons || addons.length === 0) {
          // No addons, return original response
          return Promise.resolve(originalResponse);
        }

        console.log('Adding design add-ons to cart:', addons);

        // Add each addon product to cart sequentially
        const addAddonSequentially = (index, lastResponse = null) => {
          if (index >= addons.length) {
            // All addons added, use the last response which should have sections
            console.log('All addons added, using last response with sections');
            if (lastResponse && lastResponse.sections) {
              return Promise.resolve(lastResponse);
            }
            // Fallback: fetch updated cart sections
            console.log('No sections in last response, fetching updated cart sections...');
            return this.fetchUpdatedCartSections(originalFormData);
          }

          const addon = addons[index];
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          
          // Use FormData format for Shopify cart API
          const addonFormData = new FormData();
          addonFormData.append('id', addon.id);
          addonFormData.append('quantity', addon.quantity);
          
          // Include sections if cart exists
          if (this.cart) {
            addonFormData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            addonFormData.append('sections_url', window.location.pathname);
          }
          
          config.body = addonFormData;

          console.log(`Attempting to add addon ${addon.id} to cart`);

          return fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(data => {
              console.log(`Added addon ${addon.id} to cart:`, data);
              if (data.status) {
                console.error(`Error adding addon ${addon.id}:`, data.description);
                // Continue even if there's an error
                return addAddonSequentially(index + 1, lastResponse);
              }
              // Use this response (it has the latest cart state with sections)
              return addAddonSequentially(index + 1, data);
            })
            .catch(error => {
              console.error(`Error adding design addon ${addon.id} to cart:`, error);
              // Continue even if there's an error
              return addAddonSequentially(index + 1, lastResponse);
            });
        };

        return addAddonSequentially(0, originalResponse);
      }

      fetchUpdatedCartSections(originalFormData) {
        if (!this.cart) {
          return Promise.resolve({ success: true });
        }

        const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
        const sectionsUrl = originalFormData.get('sections_url') || window.location.pathname;

        return fetch(`${sectionsUrl}?sections=${sectionsToRender.join(',')}`)
          .then(response => response.json())
          .then(data => {
            console.log('Fetched updated cart sections:', data);
            return data;
          })
          .catch(error => {
            console.error('Error fetching updated cart sections:', error);
            return { success: true };
          });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
